import React from "react";
import { Text } from "@blueprintjs/core";
import { FaList, FaEdit } from "react-icons/fa";
import { Maybe, UUID } from "common-types";

import { OpenEditLeaderboardDialog } from "../Layout";
import { ILeaderboard } from "../../stateUtils";
import {
  StyledContainer,
  StyledLeaderboardsList,
  StyledLeaderboardItem,
  StyledAddLeaderboardBtn,
  StyledEditLeaderboardBtn
} from "./styles";

export interface IProps {
  currentLeaderboardId: Maybe<UUID>;
  leaderboards: ILeaderboard[];
  openCreateLeaderboardDialog: () => any;
  openEditLeaderboardDialog: OpenEditLeaderboardDialog;
  setCurrentLeaderboardId: (id: UUID) => any;
}

export default ({
  currentLeaderboardId,
  leaderboards,
  openCreateLeaderboardDialog,
  openEditLeaderboardDialog,
  setCurrentLeaderboardId,
}: IProps) => {
  return (
    <StyledContainer>
      <StyledLeaderboardsList>
        {leaderboards.map(leaderboard => {
          const editBtnId = `edit-leaderboard-btn-${leaderboard.id}`;

          return (
            <StyledLeaderboardItem
              key={leaderboard.id}
              isSelected={leaderboard.id === currentLeaderboardId}
              onClick={event => {
                const editLeaderboardBtn = document.getElementById(editBtnId);

                const clickedEditBtn =
                  (event.target === editLeaderboardBtn) ||
                  (editLeaderboardBtn &&
                    editLeaderboardBtn.contains &&
                    editLeaderboardBtn.contains(event.target as HTMLElement));

                if (clickedEditBtn) return;

                setCurrentLeaderboardId(leaderboard.id);
              }}
            >
              <FaList
                style={{
                  marginRight: "10px",
                  minWidth: "15px",
                }}
              />
              <div style={{ width: "100%", paddingRight: "5px", overflow: "hidden" }}>
                <Text ellipsize>{leaderboard.title}</Text>
              </div>
              <StyledEditLeaderboardBtn
                id={editBtnId}
                title="Edit leaderboard"
                isSelected={leaderboard.id === currentLeaderboardId}
                onClick={() => openEditLeaderboardDialog(leaderboard)}
              >
                <FaEdit />
              </StyledEditLeaderboardBtn>
            </StyledLeaderboardItem>
          );
        })}
      </StyledLeaderboardsList>

      <StyledAddLeaderboardBtn
        onClick={openCreateLeaderboardDialog}
      >
        Add new leaderboard...
      </StyledAddLeaderboardBtn>
    </StyledContainer>
  );
};
